/* eslint-disable react/no-unescaped-entities */
import LegalLayout from "./LegalLayout";
import { COMPANY } from "./_company";

export default function MentionsLegales() {
  return (
    <LegalLayout
      eyebrow="Informations légales"
      title="Mentions légales"
      lastUpdated={COMPANY.effectiveDate}
      intro="Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie numérique (LCEN)."
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>bayo-mag.com</strong> (« le Site ») est édité par :
      </p>
      <ul>
        <li><strong>Nom / Raison sociale :</strong> {COMPANY.name}</li>
        <li><strong>Forme juridique :</strong> {COMPANY.legalForm}</li>
        <li><strong>Capital social :</strong> {COMPANY.capital}</li>
        <li><strong>Siège social :</strong> {COMPANY.address}</li>
        <li><strong>SIRET / RCS :</strong> {COMPANY.registration}</li>
        <li><strong>Numéro TVA intracommunautaire :</strong> {COMPANY.vat}</li>
        <li><strong>Email :</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li><strong>Téléphone :</strong> {COMPANY.phone}</li>
        <li><strong>Directeur·rice de la publication :</strong> {COMPANY.publisher}</li>
      </ul>

      <h2>2. Hébergeur</h2>
      <p>Le site est hébergé par :</p>
      <ul>
        <li><strong>{COMPANY.hosting.name}</strong></li>
        <li>{COMPANY.hosting.address}</li>
        <li>Contact : <a href={`mailto:${COMPANY.hosting.contact}`}>{COMPANY.hosting.contact}</a></li>
      </ul>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu du Site (textes, recettes originales, photographies, illustrations,
        logo, charte graphique, code source) est protégé par le droit d'auteur et reste la propriété
        exclusive de {COMPANY.name}, sauf mention contraire. Toute reproduction, représentation, modification,
        publication, adaptation, totale ou partielle, des éléments du Site, quel que soit le moyen ou le
        procédé utilisé, est interdite sans autorisation écrite préalable.
      </p>
      <p>
        Les recettes proposées par la communauté restent la propriété de leurs auteur·rice·s. En les
        soumettant via le formulaire prévu à cet effet, l'auteur·rice concède à {COMPANY.name} un droit
        non exclusif d'usage, de reproduction et d'affichage sur le Site et ses supports de communication
        (réseaux sociaux, newsletter, ebooks).
      </p>

      <h2>4. Données personnelles</h2>
      <p>
        Les modalités de collecte et de traitement des données personnelles sont détaillées dans notre{" "}
        <a href="/legal/confidentialite">Politique de confidentialité (RGPD)</a>.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Le Site utilise un nombre minimal de cookies techniques (session d'authentification, panier),
        nécessaires à son bon fonctionnement. Aucun cookie publicitaire tiers n'est déposé sans votre
        consentement explicite. Pour en savoir plus, consultez notre Politique de confidentialité.
      </p>

      <h2>6. Loi applicable et juridiction</h2>
      <p>
        Les présentes mentions légales sont régies par le droit français. En cas de litige, et après
        recherche d'une solution amiable, les tribunaux français seront seuls compétents.
      </p>
    </LegalLayout>
  );
}
